import React from "react";
import { Table } from "reactstrap";

export const DataTitles = (props) => {
  const data = props.data;

  const contribuyente = data.contribuyente;
  const valorPagar = data.valorAPagar.toString();

  const fillTitles = (impuestos) =>
    impuestos.map((accounts, index) => {
      const totalAccounts = accounts.nTitulos;
      const rows = [];
      accounts.cuentas.map((account) => {
        const catastralKey = `${account.clave}: `;
        account.titulos.map((title, idx) => {
          rows.push(
            <tr key={rows.length}>
              {rows.length === 0 ? (
                <td rowSpan={totalAccounts}>
                  <span className="align-middle font-weight-bold">
                    {accounts.denominacion}
                  </span>
                </td>
              ) : null}
              <td>
                <strong>{catastralKey}</strong>
                {account.denominacion}
              </td>
              <td>
                {title.concepto} <br />{" "}
                <span className="text-secondary">{account.datoAdicional}</span>
              </td>
              <td className="col-totals">{title.total.toFixed(2)}</td>
            </tr>
          );
        });
      });
      return rows;
    });

  const getTotalTitles = (impuestos) => impuestos.length;

  return (
    <>
      <div id="cont-table">
        <h3 className="text-center">Valores a Pagar</h3>
        <p>
          <strong>Contribuyente: </strong> {contribuyente.razonSocial}
        </p>
        <Table responsive className="mt-1">
          <thead>
            <tr>
              <th>Impuesto</th>
              <th>Predio</th>
              <th>Concepto</th>
              <th id="column-values">Valor a pagar</th>
            </tr>
          </thead>
          <tbody>
            {getTotalTitles(data.impuestos) > 0 ? (
              fillTitles(data.impuestos)
            ) : (
              <tr colSpan="4">
                <td>No existen valores a pagar.</td>
              </tr>
            )}
            <tr>
              <td></td>
              <td></td>
              <td>Total</td>
              <td className="col-totals">
                $ <strong>{valorPagar}</strong>
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    </>
  );
};
